export default "__VITE_ASSET__CmWsi$R3__"